import React, { PureComponent } from 'react';
import { Button } from 'react-bootstrap';

import Spinner from './spinner/Spinner';
import Loading from './loading/Loading';

class LoadingButton extends PureComponent {

  render () {
    const { children, className = '', loading, disabled, replace, onClick, ...rest } = this.props;

    if (replace === true) {
      return <Loading />
    }

    return (
      <Button { ...rest }
        className={ `${className} btn-with-spinner spinner-right` }
        disabled={ loading === true || disabled === true }
        onClick={ loading !== true && disabled !== true ? onClick : null }
      >
        { children }
        { loading && <Spinner /> }
      </Button>
    )
  }

};

export default LoadingButton;